import { useContext } from 'react';

import { Select } from '@atom/mui';
import { POLICY_GRANT_IDS_ALL } from '@atom/types/policy';

import PolicyModalContext from './PolicyModalContext';

const { MenuItem } = Select;

const PolicyTeamChatSelection = () => {
  const { state, updateState } = useContext(PolicyModalContext);
  const { grants, grantType, loadingExistingPolicies } = state;

  const handleChange = event => {
    updateState({ grants: [{ id: event.target.value, name: grantType }] });
  };

  return (
    <Select
      loading={loadingExistingPolicies}
      label="Channel(s)"
      value={grants[0]?.id || ''}
      onChange={handleChange}
    >
      <MenuItem value={POLICY_GRANT_IDS_ALL}>All</MenuItem>
    </Select>
  );
};

export default PolicyTeamChatSelection;
